import React from "react";
import { useNavigate } from "react-router-dom";

const CustomToast = ({ message }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100%", // Takes full width of the container
        padding: "5px",
        borderRadius: "8px",
        backgroundColor: "#e6f4ea", // Subtle green background
        color: "#2e7d32", // Darker green for text
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          fontSize: "36px",
          marginBottom: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        ✔ {/* Icon */}
      </div>
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          marginBottom: "5px",
        }}
      >
        {message}
      </div>
      <p style={{ fontSize: "14px", margin: 0 }}>was added to your cart</p>
      <button
        style={{
          marginTop: "15px",
          padding: "10px 20px",
          border: "1px solid #2e7d32",
          borderRadius: "4px",
          backgroundColor: "white",
          color: "#2e7d32",
          cursor: "pointer",
          fontWeight: "bold",
          transition: "all 0.3s ease",
        }}
        // onClick={() => navigate("/checkout")}
        onClick={() => navigate("/cart")}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = "#2e7d32";
          e.target.style.color = "white";
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = "white";
          e.target.style.color = "#2e7d32";
        }}
      >
        View Cart
      </button>
    </div>
  );
};

export default CustomToast;
